// import { FiMap, FiBookOpen, FiFileText } from "react-icons/fi";

// const countries = [
//   { name: "United Arab Emirates", region: "Middle East", focus: "Trade, Energy, Logistics", gdp: "USD 500 B", trade: "USD 68 B", iconColor: "from-[#DB6400] to-[#F59C00]" },
//   { name: "Germany", region: "Europe", focus: "Manufacturing, Auto, Tech", gdp: "USD 4.6 T", trade: "USD 3.2 T", iconColor: "from-[#DA2128] to-[#DB2628]" },
//   { name: "United States", region: "Americas", focus: "Innovation, Pharma, Defence", gdp: "USD 27 T", trade: "USD 5.8 T", iconColor: "from-[#DB6400] to-[#F59C00]" },
//   { name: "Japan", region: "Asia Pacific", focus: "Electronics, Automotive, Retail", gdp: "USD 4.2 T", trade: "USD 1.3 T", iconColor: "from-[#DA2128] to-[#DB2628]" },
//   { name: "South Africa", region: "Africa", focus: "Mining, Agriculture, Energy", gdp: "USD 380 B", trade: "USD 210 B", iconColor: "from-[#DB6400] to-[#F59C00]" },
//   { name: "Brazil", region: "Americas", focus: "Agriculture, Energy, Manufacturing", gdp: "USD 2.1 T", trade: "USD 680 B", iconColor: "from-[#DA2128] to-[#DB2628]" },
// ];

// export default function CountryDossiers() {
//   return (
//     <section id="dossiers" className="scroll-mt-28 space-y-16">
//       <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#DA2128] to-[#DB2628] px-8 py-14 md:px-16 md:py-20 shadow-2xl shadow-[#DA2128]/20">
//         <div className="absolute -top-16 left-1/2 h-72 w-72 rounded-full bg-white/10 blur-3xl -translate-x-1/2" />
//         <div className="relative z-10 max-w-4xl text-center mx-auto">
//           <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-sm font-medium text-white backdrop-blur-md border border-white/10">
//             <FiFileText className="h-4 w-4" /> Intelligence Reports
//           </div>
//           <h2 className="font-['Cormorant_Garamond'] text-5xl md:text-7xl font-semibold text-white leading-[0.95] tracking-tight">
//             Country <span className="italic font-normal">Dossiers</span>
//           </h2>
//           <p className="mt-6 max-w-2xl mx-auto text-lg text-white/90 leading-relaxed font-light">
//             Detailed country profiles covering macroeconomics, regulatory frameworks, sector opportunities, trade barriers, and strategic entry pathways.
//           </p>
//         </div>
//       </div>

//       <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
//         {countries.map((c) => (
//           <a key={c.name} href="#" className="group flex flex-col rounded-3xl bg-white border border-[#FEF7F4] p-8 shadow-xl shadow-black/[0.03] hover:-translate-y-1.5 hover:shadow-2xl hover:border-[#DA2128]/20 transition-all duration-300 overflow-hidden relative">
//             <div className={`absolute top-0 left-0 h-2 w-full bg-gradient-to-r ${c.iconColor}`} />
//             <div className="flex items-center justify-between mb-5">
//               <div className={`h-12 w-12 rounded-xl bg-gradient-to-br ${c.iconColor} text-white flex items-center justify-center text-xl shadow-lg`}>
//                 <FiMap />
//               </div>
//               <span className="text-xs font-bold text-[#9a9aab] uppercase tracking-wider">{c.region}</span>
//             </div>
//             <h3 className="text-xl font-semibold text-[#1a1a2e] mb-1 font-['Outfit'] group-hover:text-[#DA2128] transition-colors">{c.name}</h3>
//             <p className="text-sm text-[#DB6400] font-semibold mb-5">{c.focus}</p>
//             <div className="grid grid-cols-2 gap-3 mb-5">
//               <div className="rounded-xl bg-[#FAF7F2] p-3 text-center">
//                 <div className="text-xs text-[#9a9aab] font-medium">GDP</div>
//                 <div className="font-bold text-[#1a1a2e]">{c.gdp}</div>
//               </div>
//               <div className="rounded-xl bg-[#FAF7F2] p-3 text-center">
//                 <div className="text-xs text-[#9a9aab] font-medium">Trade</div>
//                 <div className="font-bold text-[#1a1a2e]">{c.trade}</div>
//               </div>
//             </div>
//             <div className="mt-auto flex items-center gap-2 text-sm font-semibold text-[#DA2128] group-hover:translate-x-1 transition-transform">
//               Read Dossier <span>→</span>
//             </div>
//           </a>
//         ))}
//       </div>

//       <div className="rounded-3xl bg-gradient-to-r from-[#FAF7F2] to-[#FEF7F4] p-10 md:p-14 border border-[#FEF7F4] flex flex-col md:flex-row gap-10 items-start md:items-center shadow-xl shadow-black/[0.02]">
//         <div className="flex-shrink-0 h-20 w-20 rounded-3xl bg-gradient-to-br from-[#DB6400] to-[#F59C00] text-white flex items-center justify-center text-3xl shadow-xl shadow-[#DB6400]/20">
//           <FiBookOpen />
//         </div>
//         <div className="flex-1">
//           <h3 className="text-3xl font-semibold text-[#1a1a2e] mb-3 font-['Cormorant_Garamond'] tracking-tight">Access Full Reports</h3>
//           <p className="text-[#4a4a5a] leading-relaxed max-w-2xl">
//             ASSOCHAM members receive free access to country dossiers, commercial reports, and sectoral briefings through the International Division portal. Custom research and market-entry studies are available on request.
//           </p>
//         </div>
//         <a href="#" className="inline-flex items-center gap-2 rounded-full bg-[#DA2128] text-white px-7 py-3.5 font-semibold text-sm shadow-xl shadow-[#DA2128]/25 hover:bg-[#DB2628] transition-colors whitespace-nowrap">Member Access →</a>
//       </div>
//     </section>
//   );
// }




// new code 






import { useState } from "react";
import { FiMap, FiBookOpen, FiZap, FiArrowUpRight, FiSearch } from "react-icons/fi";
import { motion, AnimatePresence } from "framer-motion";

const countries = [
  { name: "United Arab Emirates", region: "Middle East", focus: "Trade, Energy, Logistics", gdp: "USD 500 B", trade: "USD 68 B", iconColor: "from-[#DB6400] to-[#F59C00]" },
  { name: "Germany", region: "Europe", focus: "Manufacturing, Auto, Tech", gdp: "USD 4.6 T", trade: "USD 3.2 T", iconColor: "from-[#DA2128] to-[#DB2628]" },
  { name: "United States", region: "Americas", focus: "Innovation, Pharma, Defence", gdp: "USD 27 T", trade: "USD 5.8 T", iconColor: "from-[#DB6400] to-[#F59C00]" },
  { name: "Japan", region: "Asia Pacific", focus: "Electronics, Automotive, Retail", gdp: "USD 4.2 T", trade: "USD 1.3 T", iconColor: "from-[#DA2128] to-[#DB2628]" },
  { name: "South Africa", region: "Africa", focus: "Mining, Agriculture, Energy", gdp: "USD 380 B", trade: "USD 210 B", iconColor: "from-[#DB6400] to-[#F59C00]" },
  { name: "Brazil", region: "Americas", focus: "Agriculture, Energy, Manufacturing", gdp: "USD 2.1 T", trade: "USD 680 B", iconColor: "from-[#DA2128] to-[#DB2628]" },
];

const regions = ["All", "Middle East", "Europe", "Americas", "Asia Pacific", "Africa"];

export default function CountryDossiers() {
  const [activeRegion, setActiveRegion] = useState("All");

  const filteredCountries = activeRegion === "All" 
    ? countries 
    : countries.filter(c => c.region === activeRegion);

  return (
    <section id="dossiers" className="scroll-mt-20 py-4 max-w-7xl mx-auto space-y-8">
      {/* Header & Filter Controls */}
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 border-b border-gray-100 pb-5">
        <div>
          <div className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-[#DA2128]/10 px-3 py-1 text-xs font-semibold text-[#DA2128]">
            <FiZap className="h-3.5 w-3.5 animate-pulse" />
            <span>Intelligence Reports</span>
          </div>
          <h2 className="font-['Cormorant_Garamond'] text-3xl md:text-5xl font-semibold text-[#1a1a2e] leading-tight tracking-tight">
            Country <span className="italic font-normal text-[#F59C00]">Dossiers</span>
          </h2>
        </div>

        {/* Region Filter Pills */}
        <div className="flex flex-wrap items-center gap-1.5 bg-[#FAF7F2] p-1.5 rounded-2xl border border-gray-100">
          {regions.map((region) => (
            <button
              key={region}
              onClick={() => setActiveRegion(region)}
              className={`px-3 py-1.5 text-xs font-semibold rounded-xl transition-all duration-200 ${
                activeRegion === region
                  ? "bg-[#DA2128] text-white shadow-md shadow-[#DA2128]/20"
                  : "text-[#6a6a7a] hover:text-[#1a1a2e] hover:bg-white/60"
              }`}
            >
              {region}
            </button>
          ))}
        </div>
      </div>

      {/* Country Cards Grid */}
      <motion.div layout className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        <AnimatePresence>
          {filteredCountries.map((c) => (
            <motion.a
              key={c.name}
              href="#"
              layout
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ duration: 0.3 }}
              className="group flex flex-col rounded-2xl bg-white border border-[#FEF7F4] p-6 shadow-sm hover:shadow-xl hover:border-[#DA2128]/30 hover:-translate-y-1 transition-all duration-300 overflow-hidden relative"
            >
              {/* Animated Top Border Gradient */}
              <div className={`absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r ${c.iconColor} scale-x-100 group-hover:h-2 transition-all duration-300`} />

              <div className="flex items-center justify-between mb-4 pt-1">
                <div className={`h-11 w-11 rounded-xl bg-gradient-to-br ${c.iconColor} text-white flex items-center justify-center text-lg shadow-md group-hover:scale-105 transition-transform`}>
                  <FiMap />
                </div>
                <span className="text-[11px] font-bold text-[#9a9aab] uppercase tracking-wider bg-[#FAF7F2] px-2.5 py-1 rounded-md">
                  {c.region}
                </span>
              </div>

              <h3 className="text-lg font-semibold text-[#1a1a2e] mb-1 font-['Outfit'] group-hover:text-[#DA2128] transition-colors">
                {c.name}
              </h3>
              <p className="text-xs text-[#DB6400] font-semibold mb-4">{c.focus}</p>

              {/* GDP & Trade Stats Box */}
              <div className="grid grid-cols-2 gap-2.5 mb-5">
                <div className="rounded-xl bg-[#FAF7F2] p-2.5 text-center border border-gray-50">
                  <div className="text-[10px] text-[#9a9aab] font-medium uppercase tracking-wider">GDP</div>
                  <div className="font-bold text-sm text-[#1a1a2e]">{c.gdp}</div>
                </div>
                <div className="rounded-xl bg-[#FAF7F2] p-2.5 text-center border border-gray-50">
                  <div className="text-[10px] text-[#9a9aab] font-medium uppercase tracking-wider">Trade</div>
                  <div className="font-bold text-sm text-[#1a1a2e]">{c.trade}</div>
                </div>
              </div>

              <div className="mt-auto flex items-center gap-1 text-xs font-semibold text-[#DA2128] group-hover:translate-x-1 transition-transform">
                Read Dossier <FiArrowUpRight className="h-4 w-4" />
              </div>
            </motion.a>
          ))}
        </AnimatePresence>
      </motion.div>

      {/* Styled Full Reports Banner */}
      {/* <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-[#1a1a2e] via-[#2a2a40] to-[#1a1a2e] p-8 md:p-10 text-white shadow-xl shadow-black/10">
        <div className="absolute top-0 right-0 h-48 w-48 rounded-full bg-[#DA2128]/20 blur-3xl pointer-events-none" />
        <div className="absolute bottom-0 left-1/3 h-32 w-32 rounded-full bg-[#DB6400]/20 blur-2xl pointer-events-none" />

        <div className="relative z-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex items-start md:items-center gap-5">
            <div className="shrink-0 h-14 w-14 rounded-2xl bg-gradient-to-br from-[#DB6400] to-[#F59C00] text-white flex items-center justify-center text-2xl shadow-lg shadow-[#DB6400]/20">
              <FiBookOpen />
            </div>
            <div>
              <h3 className="text-2xl font-semibold text-white mb-1.5 font-['Cormorant_Garamond'] tracking-tight">
                Access Full Commercial Reports
              </h3>
              <p className="text-xs md:text-sm text-white/80 leading-relaxed max-w-2xl font-light">
                ASSOCHAM members receive complimentary access to full country dossiers, sectoral briefings, and trade barrier studies through our portal.
              </p>
            </div>
          </div>

          <a 
            href="#" 
            className="shrink-0 inline-flex items-center gap-2 rounded-full bg-[#DA2128] hover:bg-[#DB2628] text-white px-6 py-3 font-semibold text-xs transition-colors shadow-lg shadow-[#DA2128]/30"
          >
            Member Access <FiArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </div> */}
    </section>
  );
}